import { Checkbox, Modal } from 'antd';
import React, { FC, useContext, useEffect, useState } from 'react';
import { CancelButton, CustomButton } from './SaveSelectionPresetsModal';
import { CustomSelect } from 'components/template/BumpReport/MainSection';
import DownSvg from 'assets/svg/Down';
import { FilterContextData } from 'contexts/FilterContext';
import Loader from '../Loader';
interface Props {
    isOpen: boolean;
    loading: boolean;
    setIsOpen: Function;
    onLoad: Function;
    presetsList?: any;
}
const LoadPresetsModal: FC<Props> = ({ presetsList, isOpen, setIsOpen, onLoad, loading }) => {
    const { selectedPresetInfoObj, setSelectedPresetInfoObj } = useContext(FilterContextData);
    const [tempSelectedValue, setTempSelectedValue] = useState({ ...selectedPresetInfoObj });

    const closeModal = () => {
        setIsOpen(false);
        setTempSelectedValue({ label: '', value: '', isDefault: false });
    };

    return (
        <Modal
            bodyStyle={{ padding: 16 }}
            open={isOpen}
            destroyOnClose
            centered
            footer={''}
            width={400}
            onCancel={() => closeModal()}
        >
            <div className="font-lg font-medium mb-6">Load Preset</div>
            {loading ? (
                <Loader style={{ height: 150 }} />
            ) : (
                <>
                    <p className="font-medium font-md leading-[normal]">Select Preset</p>
                    <div className="my-2">
                        <CustomSelect
                            showSearch
                            placeholder="Select Preset"
                            className="dropdown-height w-full uniqSelLoadPresetDropdown"
                            suffixIcon={<DownSvg />}
                            loading={loading}
                            value={tempSelectedValue?.value || undefined}
                            disabled={false}
                            options={presetsList}
                            onChange={(val: any, item: any) => {
                                setTempSelectedValue(item);
                            }}
                        />
                    </div>

                    <div className="flex items-center gap-2 mb-4">
                        <Checkbox
                            disabled={!tempSelectedValue?.value}
                            value={tempSelectedValue.isDefault}
                            checked={tempSelectedValue.isDefault}
                            onChange={(e) =>
                                setTempSelectedValue({ ...tempSelectedValue, isDefault: e.target.checked })
                            }
                        />
                        <p className="text-greyFont font-xs">Make this default</p>
                    </div>
                    <div className="flex justify-end items-center gap-2">
                        <CancelButton onClick={() => closeModal()}>Cancel</CancelButton>
                        <CustomButton
                            disabled={!tempSelectedValue?.value}
                            onClick={() => {
                                onLoad({ ...tempSelectedValue });
                                closeModal();
                            }}
                        >
                            Load
                        </CustomButton>
                    </div>
                </>
            )}
        </Modal>
    );
};

export default LoadPresetsModal;
